/*
 *   File : tab.js
 *   Author : https://evoqins.com
 *   Description : Custom tab component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';

//Style
import styles from "../../Styles/Component/others.module.scss";

const CustomTab = (props) => {
    return (
        <p className={`${props.className} ${props.tabIndex === props.data.id ? `${styles.e_tab} cursor-default e-text-white` : 'cursor-pointer e-text-pale-lavender padding-12px-bottom'} mb-0 e-alt-font-lato e-font-14-res e-font-16 e-font-weight-600 line-height-20px`}
            onClick={() => props.handleClick(props.data.id)}>
            {props.data.label}
        </p>
    )
}

export default CustomTab;
